(function() {
  angular.module('uiGmapgoogle-maps.directives.api.utils').service('uiGmapIsReady', [
    '$q', '$timeout', function($q, $timeout) {
      var _checkIfReady, _ctr, _currentCheckNum, _maxCtrChecks, _promises, _proms;
      _ctr = 0;
      _proms = [];
      _currentCheckNum = 1;
      _maxCtrChecks = 50;
      _promises = function() {
        return $q.all(_proms);
      };
      _checkIfReady = function(deferred, expectedInstances) {
        return $timeout(function() {
          if (_currentCheckNum >= _maxCtrChecks) {
            deferred.reject('Your maps are not found we have checked the maximum amount of times. :)');
          }
          _currentCheckNum += 1;
          if (_ctr !== expectedInstances) {
            return _checkIfReady(deferred, expectedInstances);
          } else {
            return deferred.resolve(_promises());
          }
        }, 100);
      };
      return {
        spawn: function() {
          var d;
          d = $q.defer();
          _proms.push(d.promise);
          _ctr += 1;
          return {
            instance: _ctr,
            deferred: d
          };
        },
        promises: _promises,
        instances: function() {
          return _ctr;
        },
        promise: function(expectedInstances) {
          var d;
          if (expectedInstances == null) {
            expectedInstances = 1;
          }
          d = $q.defer();
          _checkIfReady(d, expectedInstances);
          return d.promise;
        },
        reset: function() {
          _ctr = 0;
          _proms.length = 0;
        },
        decrement: function() {
          if (_ctr > 0) {
            _ctr -= 1;
          }
          if (_proms.length) {
            _proms.length -= 1;
          }
        }
      };
    }
  ]);

}).call(this);
